<template>
  <div style="padding:20px; width:100%;height:100%;background: white;font-size:16px;display: flex;flex-direction: column;">
    <h2 style="font-size:18px; margin:0 0 16px;">数据看板</h2>

    <!-- 输入区（替换原来的） -->
  <div style="display:flex; gap:12px; margin-bottom:16px; flex-wrap:wrap;">
    <input v-model="code" placeholder="请输入身份验证码" style="width:160px; padding:8px 12px; border:1px solid #dcdfe6; border-radius:4px; outline:none;" />
    
    <select v-model="action">
      <option value="1">按日期区间查询</option>
      <option value="2">按手机号码查询</option>
      <option value="3">按激活码查询</option>
    </select>
    
    <input v-if="action==1" v-model="st_time" type="date" style="padding:8px 12px; border:1px solid #dcdfe6; border-radius:4px; outline:none;" />
    <span v-if="action==1" style="line-height:36px; color:#999;">至</span>
    <input v-if="action==1" v-model="ed_time" type="date" style="padding:8px 12px; border:1px solid #dcdfe6; border-radius:4px; outline:none;" />

    <input v-if="action==2" v-model="phone_num" placeholder="请输入手机号码" style="width:150px; padding:8px 12px; border:1px solid #dcdfe6; border-radius:4px; outline:none;" />

    <input v-if="action==3" v-model="active_code" placeholder="请输入激活码" style="width:150px; padding:8px 12px; border:1px solid #dcdfe6; border-radius:4px; outline:none;" />

    <button @click="fetchData" :disabled="loading" style="padding:8px 12px; background:#409EFF; color:#fff; border:none; border-radius:4px; cursor:pointer;">{{ loading ? '加载中' : '查询' }}</button>

    <button v-if="action==2" @click="phoneWhitelist" style="padding:8px 12px; background:#409EFF; color:#fff; border:none; border-radius:4px; cursor:pointer;">免短信注册</button>

    <button v-if="action==2 || action==3" @click="cancelVip" style="padding:8px 12px; background:#409EFF; color:#fff; border:none; border-radius:4px; cursor:pointer;">撤销会员</button>
  </div>

  <div v-if="list.length" style="margin-bottom: 5px;">数量: <span style="color:green">{{ list.length }}</span></div>
  <!-- 表头 -->
  <div v-if="list.length" style="display:grid; grid-template-columns:1.5fr 2.0fr 1.5fr 1.5fr 1.5fr 1.5fr; background:#f5f7fa; font-weight:600; border-bottom:2px solid #e4e7ed;">
    <div v-for="h in ['账号信息','购买类型','激活码','当前购买状态','账号创建时间','购买时间']" :key="h" style="padding:10px 14px; border-left:1px solid #e4e7ed;">{{ h }}</div>
  </div>
  <!-- 数据行 -->
  <div v-if="list.length" style="flex:1;overflow: auto;border: 1px solid #999;">
    <div v-for="(item, idx) in list" :key="idx" style="display:grid; grid-template-columns:1.5fr 2.0fr 1.5fr 1.5fr 1.5fr 1.5fr;" :style="idx%2===0 ? {background:'#fff'} : {background:'#fafafa'}">
      <div v-for="(col, ci) in item" :key="ci" style="padding:10px 14px; border-bottom:1px solid #e4e7ed; border-left:1px solid #e4e7ed;">{{ col || '-' }}</div>
    </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    
    const sevenDaysAgo = new Date(tomorrow)
    sevenDaysAgo.setDate(tomorrow.getDate() - 7)
    
    const fmt = d => d.toISOString().slice(0, 10)
    
    return {
      code: '',
      action: '1',
      st_time: fmt(sevenDaysAgo),
      ed_time: fmt(tomorrow),
      phone_num: '',
      active_code: '',
      list: [],
      loading: false
    }
  },
  methods: {
    async fetchData() {
      if(this.loading) return
      if (!this.code.trim()) return alert('请输入身份验证码')
      
      let search_type = parseInt(this.action)
      
      let request_data = {
        type:'sale_dashboard',
        admin_code:this.code,
        data:{ search_type:search_type}
      }
      if(search_type == 1) {
        if (!this.st_time || !this.ed_time) return alert('请选择日期范围')
        request_data.data.st_time = this.st_time
        request_data.data.ed_time = this.ed_time
      } else if(search_type == 2) {
        if (!this.phone_num.trim()) return alert('请输入11位手机号码')
        request_data.data.phone_num = this.phone_num
      } else if(search_type == 3) {
        if (!this.active_code.trim()) return alert('请输入激活码')
        request_data.data.active_code = this.active_code
      }
      this.loading = true
    
      await axios.post('https://caixiaowen.com/hsraz', request_data)
      .then((res) =>{
        if (res.data.err_no === 0){
          this.list = res.data.sale_list
        } else alert('拉取失败')
      }).catch((error) =>{
        console.log(error)
      })
      this.loading = false
    },
    async phoneWhitelist() {
      if (!this.code.trim()) return alert('请输入身份验证码')
      if (!this.phone_num.trim()) return alert('请输入11位手机号码')
      await axios.post('https://caixiaowen.com/hsraz', {
        type:'phone_whitelist',
        admin_code:this.code,
        data:{ phone_number:this.phone_num}
      })
      .then((res) =>{
        if (res.data.err_no === 0) alert('白名单添加成功')
      }).catch((error) =>{
        console.log(error)
      })
    },
    async cancelVip() {
      if (!this.code.trim()) return alert('请输入身份验证码')
      
      let request_data = {
        type:'cancel_vip',
        admin_code:this.code,
        data:{}
      }

      let search_type = parseInt(this.action)
      if(search_type == 2) {
        if (!this.phone_num.trim()) return alert('请输入11位手机号码')
        request_data.data.phone_num = this.phone_num
      } else if(search_type == 3) {
        if (!this.active_code.trim()) return alert('请输入激活码')
        request_data.data.active_code = this.active_code
      }
    
      await axios.post('https://caixiaowen.com/hsraz', request_data)
      .then((res) =>{
        alert(res.data.err_info)
      }).catch((error) =>{
        console.log(error)
      })
    },
  }
}
</script>
